<template>
  <div class="container">
    <v-row>
      <v-col>
        Alert
      </v-col>
      <v-col>
        <v-btn
          @click="setUpNotificationChannel"
          class="text-bold float-right"
          color="error"
          small
        >
          <v-icon left>mdi-settings</v-icon>
          ตั้งค่าการแจ้งเตือน
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" fullscreen content-class="alert-dialog">
      <v-card>
        <v-btn icon @click="closeDialog" dark class="alert-dialog-close">
          <v-icon color="black">mdi-close</v-icon>
        </v-btn>
        <img :src="src" alt="graph">
      </v-card>
    </v-dialog>

    <v-dialog v-model="setting_dialog" max-width="250">
      <v-card>
        <div class="text-right">
          <v-btn icon @click="setting_dialog = false" dark>
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="px-4">
          <div>
            <v-switch v-model="is_email_notify" inset label="แจ้งเตือนอีเมล" color="info" class="mt-0"/>
          </div>
          <div>
            <v-switch v-model="is_line_notify" inset label="แจ้งเตือนไลน์" color="info" class="mt-0"/>
          </div>
          <div class="text-right">
            <v-btn small color="primary" class="mb-3" @click="saveUpNotificationChannel">บันทึก</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :color="success ? 'success' : 'error'"
      :timeout="3000"
      top
    >
      {{ success ? 'บันทึกสำเร็จ' : 'บันทึกไม่สำเร็จ' }}

      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-list
      dark
      flat
      class="alert-list"
    >
      <v-list-item-group>
        <v-list-item
          v-for="(alert, index) in alerts"
          :key="index"
          class="bg-alert"
          @click="openDialog(alert)"
          cols="12">
          <v-row>
            <v-col cols="12" md="5">
              <v-badge color="red" left :value="alert.read_at === null" content="!">
                <div v-if="!!alert.data.logger">
                  {{ alert.data.logger.code }} ({{ alert.data.logger.name }})
                </div>
                <div v-else>-</div>
              </v-badge>
            </v-col>

            <v-col cols="12" md="7" class="text-md-right">
              {{ !!alert.data.branch ? alert.data.branch.name : '-' }} /
              {{ !!alert.data.district ? alert.data.district.name : '-' }} /
              {{ !!alert.data.sector ? alert.data.sector.name : '-' }} /
              {{ !!alert.data.unit ? alert.data.unit.name : '-' }}
            </v-col>

            <v-col cols="6">
              <span>สถานะ: {{ !!alert.data.data ? alert.data.data.status : '-' }}</span>
              <br/>
              <span>ข้อมูล: {{ !!alert.data.data ? alert.data.data.code : '-' }}</span>
            </v-col>

            <v-col cols="6" class="text-right">
              {{ alert.created_at | moment('add', '543 years', 'D MMMM Y, HH:mm:ss') }}
            </v-col>
          </v-row>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <infinite-loading @infinite="getAlert" spinner="bubbles"></infinite-loading>
  </div>
</template>

<script>
  import Api from '../providers/Api'
  import InfiniteLoading from 'vue-infinite-loading'

  export default {
    components: {
      InfiniteLoading,
    },

    data () {
      return {
        dialog: false,
        alerts: [],
        alert: null,
        page: 1,
        per_page: 10,
        src: null,
        setting_dialog: false,
        is_email_notify: false,
        is_line_notify: false,
        snackbar: false,
        success: false,
      }
    },

    created () {
      window.onresize = this.prepareGraph
    },

    methods: {
      getAlert ($state) {
        this.get('/api/notifications', {
          page: this.page,
          per_page: this.per_page,
        })
          .then(({ data }) => {
            this.alerts = this.alerts.concat(data.data)

            if (this.page === 1 && typeof this.$route.query.id !== 'undefined') {
              let alert = _.find(this.alerts, { id: this.$route.query.id })

              this.openDialog(alert)
            }

            if (data.last_page !== this.page) {
              this.page++
              $state.loaded()
            } else {
              $state.complete()
            }
          })
      },

      openDialog (alert) {
        // Prepare data to show graph
        if (!!alert.data.logger) {
          this.alert = alert
          this.prepareGraph()

          // Open dialog
          this.dialog = true
        }

        // Mark notification as read
        if (alert.read_at === null) {
          this.put(`/api/notifications/${ alert.id }`)
            .then(() => {
              alert.read_at = new Date()
              this.$store.state.$user.unread_notifications--
            })
        }
      },

      prepareGraph () {
        if (this.alert !== null) {
          let field = this.alert.data.data.code || 'flow'
          let from = moment(this.alert.created_at).subtract(2, 'hours').format('YYYY-MM-DDTHH:mm:ss')
          let to = moment(this.alert.created_at).add(10, 'minutes').format('YYYY-MM-DDTHH:mm:ss')

          let width = window.innerWidth
          let height = window.innerHeight

          let src = `/graph/logger/${ this.alert.data.logger.id }/${ field }/${ from }/${ to }/${ width }x${ height }.png`

          if (process.env.NODE_ENV !== 'production') {
            src = 'https://dmama2.pwa.co.th' + src
          }

          this.src = src
        }
      },

      closeDialog () {
        this.alert = null
        this.dialog = false
      },

      setUpNotificationChannel () {
        this.setting_dialog = true

        this.is_email_notify = this.$store.state.$user.is_email_notify
        this.is_line_notify = this.$store.state.$user.is_line_notify
      },

      saveUpNotificationChannel () {
        this.post('/api/users/notification', {
          is_email_notify: this.is_email_notify,
          is_line_notify: this.is_line_notify,
        })
          .then(() => {
            this.success = true
            this.snackbar = true

            this.$store.state.$user.is_email_notify = this.is_email_notify
            this.$store.state.$user.is_line_notify = this.is_line_notify

            this.setting_dialog = false
          })
          .catch(() => {
            this.success = false
            this.snackbar = true

            this.setting_dialog = false
          })
      },
    },

    mixins: [
      Api,
    ],
  }
</script>

<style lang="scss">
  .alert-list {
    background-color: transparent !important;
    margin: 0 -12px;
  }

  .bg-alert {
    background-color: #262628;
    margin-top: 10px;
  }

  .alert-dialog {
    overflow: hidden !important;

    & .alert-dialog-close {
      position: fixed;
      top: 0;
      right: 0;
    }
  }
</style>
